<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M21.9949 5.82373C21.9037 4.24892 20.5977 3 19 3H5L4.82373 3.00509C3.24892 3.09634 2 4.40232 2 6V18L2.00509 18.1763C2.09634 19.7511 3.40232 21 5 21H19L19.1763 20.9949C20.7511 20.9037 22 19.5977 22 18V6L21.9949 5.82373ZM5 5H19L19.1166 5.00673C19.614 5.06449 20 5.48716 20 6V18L19.9933 18.1166C19.9355 18.614 19.5128 19 19 19H5L4.88338 18.9933C4.38604 18.9355 4 18.5128 4 18V6L4.00673 5.88338C4.06449 5.38604 4.48716 5 5 5ZM17 12C17.5128 12 17.9355 12.386 17.9933 12.8834L18 13V16C18 16.5128 17.614 16.9355 17.1166 16.9933L17 17H14C13.4477 17 13 16.5523 13 16C13 15.4872 13.386 15.0645 13.8834 15.0067L14 15H16V13C16 12.4872 16.386 12.0645 16.8834 12.0067L17 12ZM11 8C11 7.44772 10.5523 7 10 7H7L6.88338 7.00673C6.38604 7.06449 6 7.48716 6 8V11L6.00673 11.1166C6.06449 11.614 6.48716 12 7 12L7.11662 11.9933C7.61396 11.9355 8 11.5128 8 11V9H10L10.1166 8.99327C10.614 8.93551 11 8.51284 11 8Z"
    fill="currentColor"
  />
</svg>
